import { render, staticRenderFns } from "./ReferralActionComponent.vue?vue&type=template&id=58700506"
import script from "./ReferralActionComponent.vue?vue&type=script&lang=js"
export * from "./ReferralActionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports